import { Component } from 'react'
import { connect } from 'react-redux'
import * as ACT from './actions'
import { AddProposalModal } from './AddProposalModal'

const requiredFields = ['name', 'deal', 'company', 'file']

@connect(({ deal }, ownProps) => {
  const { dealCompanies } = deal

  return {
    deal: {
      value: deal.id || ownProps.deal.value,
      label: deal.id ? deal.name : ownProps.deal.label
    },
    dealCompanies,
    ...(ownProps.createProposalCb ? { createProposalCb: ownProps.createProposalCb } : {})
  }
})
class AddProposalModalContainer extends Component {
  state = {
    firstTimeLoad: true,
    showProposalError: false,
    proposal: {
      name: '',
      file: null,
      deal: null,
      company: {}
    }
  }

  componentDidUpdate() {
    const { value, label } = this.props.deal
    if (value && this.state.firstTimeLoad) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        ...this.state,
        firstTimeLoad: false,
        proposal: {
          ...this.state.proposal,
          deal: {
            value,
            label
          }
        }
      })
    }
  }

  fetchCompanies = dealId => {
    this.props.dispatch({
      type: ACT.DEAL_COMPANIES_FETCH_REQUESTED,
      payload: {
        dealId
      }
    })
  }

  changeProposalProperty = (value, property) => {
    this.setState(prevState => ({
      proposal: { ...prevState.proposal, [property]: value }
    }))
    property === 'deal' && this.fetchCompanies(value.value)
  }

  validateRequiredFields = (proposal, cb) => {
    const emptyRequiredFields = requiredFields.filter(field => !proposal[field])
    const error = !!emptyRequiredFields.length
    this.setState({
      showProposalError: error
    })
    if (!error) {
      cb()
      this.props.toggleAddProposalModal()
      this.setState({
        showProposalError: false
      })
    }
  }

  createProposal = () => {
    const { proposal } = this.state
    const { addProposalActionType, filters, filteredByUser, fromDashboard, createProposalCb } =
      this.props
    this.validateRequiredFields(proposal, () => {
      this.props.dispatch({
        type: ACT.PROPOSAL_CREATE_REQUESTED,
        payload: {
          proposal,
          addProposalActionType,
          filters,
          userId: filteredByUser?.value,
          fromDashboard,
          createProposalCb
        }
      })
    })
  }

  upload = e => {
    const file = e.target.files[0]

    const fr = new FileReader()
    fr.onload = () => {
      this.setState(prevState => ({
        proposal: { ...prevState.proposal, file: file }
      }))
    }
    if (file) {
      fr.readAsDataURL(file)
    }
  }

  render() {
    const { showProposalError } = this.state
    const { showAddProposalModal, toggleAddProposalModal } = this.props

    return (
      <AddProposalModal
        {...this.props}
        proposal={this.state.proposal}
        showAddProposalModal={showAddProposalModal}
        toggleAddProposalModal={() => {
          toggleAddProposalModal()
          this.setState({
            showProposalError: false
          })
        }}
        changeProposalProperty={this.changeProposalProperty}
        createProposal={this.createProposal}
        uploadFile={this.upload}
        showProposalError={showProposalError}
      />
    )
  }
}

export default AddProposalModalContainer
